export default {
  'form-basic-form.basic.title': 'Basic form',
  'form-basic-form.basic.description':
    'Form pages are used to collect or verify information to users, and basic forms are common in scenarios where there are fewer data items.',

  'form-basic-form.email.required': 'Por favor insira seu email!',
  'form-basic-form.email.wrong-format': 'O email está errado!',
  'form-basic-form.userName.required': 'Por favor insira nome de usuário!',
  'form-basic-form.password.required': 'Por favor insira sua senha!',
  'form-basic-form.password.twice': 'As senhas não estão iguais!',
  'form-basic-form.strength.msg':
    'Por favor insira pelo menos 6 caracteres e não use senhas fáceis de adivinhar.',
  'form-basic-form.strength.strong': 'Força: forte',
  'form-basic-form.strength.medium': 'Força: média',
  'form-basic-form.strength.short': 'Força: curta',
  'form-basic-form.confirm-password.required': 'Por favor confirme sua senha!',
  'form-basic-form.phone-number.required': 'Por favor insira seu telefone!',
  'form-basic-form.phone-number.wrong-format': 'Formato de telefone errado!',
  'form-basic-form.verification-code.required': 'Por favor insira seu código de verificação!',

  'form-basic-form.form.get-captcha': 'Get Captcha',
  'form-basic-form.captcha.second': 'sec',
  'form-basic-form.email.placeholder': 'Email',
  'form-basic-form.password.placeholder': 'Senha',
  'form-basic-form.confirm-password.placeholder': 'Confirme a senha',
  'form-basic-form.phone-number.placeholder': 'Telefone',
  'form-basic-form.verification-code.placeholder': 'Código de verificação',
  'form-basic-form.form.optional': ' (optional) ',
  'form-basic-form.form.submit': 'Submit',
  'form-basic-form.form.save': 'Save',
  'form-basic-form.title.label': 'Title',
  'form-basic-form.title.placeholder': 'Give the target a name',
  'form-basic-form.date.label': 'Start and end date',
  'form-basic-form.placeholder.start': 'Start date',
  'form-basic-form.placeholder.end': 'End date',
  'form-basic-form.goal.label': 'Goal description',
  'form-basic-form.goal.placeholder': 'Please enter your work goals',
  'form-basic-form.standard.label': 'Metrics',
  'form-basic-form.standard.placeholder': 'Please enter a metric',
  'form-basic-form.client.label': 'Client',
  'form-basic-form.label.tooltip': 'Target service object',
  'form-basic-form.client.placeholder':
    'Please describe your customer service, internal customers directly @ Name / job number',
  'form-basic-form.invites.label': 'Inviting critics',
  'form-basic-form.invites.placeholder':
    'Please direct @ Name / job number, you can invite up to 5 people',
  'form-basic-form.weight.label': 'Weight',
  'form-basic-form.weight.placeholder': 'Please enter weight',
  'form-basic-form.public.label': 'Target disclosure',
  'form-basic-form.label.help': 'Customers and invitees are shared by default',
  'form-basic-form.radio.public': 'Public',
  'form-basic-form.radio.partially-public': 'Partially public',
  'form-basic-form.radio.private': 'Private',
  'form-basic-form.publicUsers.placeholder': 'Open to',
  'form-basic-form.option.A': 'Colleague A',
  'form-basic-form.option.B': 'Colleague B',
  'form-basic-form.option.C': 'Colleague C',
};
